export default __webpack_public_path__ + "static/media/Rules Governing Races and Logisitics.f3da7740.pdf";